import styled from '@emotion/styled'

import { mediaDown, mediaUp } from '@/styles/media'
import { spacingSection } from '@/styles/mixins'
import { mediaColumns } from '@/styles/grid'
import { colors } from '@/styles/theme'
import { Text2 } from '@/styles/typography'
import ChevronLeft from '@/components/icons/ChevronLeft'
import ChevronRight from '@/components/icons/ChevronRight'

export const LineWrapper = styled.div`
  width: calc(167px * 5);
  height: 29px;
  position: absolute;
  top: 20px;
  left: 65px;
  z-index: -1;

  ${mediaUp('md')} {
    width: calc(200px * 5);
    height: 34px;
    position: absolute;
    top: 20px;
    left: 80px;
  }

  ${mediaUp('lg')} {
    width: calc(290px * 5);
    height: 50px;
    top: 35px;
    left: 140px;
  }

  svg {
    width: 100% !important;
    height: auto;
  }

  html[lang^='ar'] & {
    left: unset;
    right: 65px;

    ${mediaUp('md')} {
      right: 80px;
    }

    ${mediaUp('lg')} {
      right: 140px;
    }
  }
`

export const Container = styled.section`
  ${spacingSection};
  overflow: hidden;
  width: 100%;

  .swiper {
    ${mediaColumns({ xs: [12, 0] })};
    width: 100%;
    overflow: visible;
  }

  .swiper-slide {
    overflow: hidden;
    padding-inline-end: 0;
    width: 167px;

    ${mediaUp('md')} {
      width: 210px;
    }

    ${mediaUp('lg')} {
      width: 290px;
    }
  }
`

export const Buttons = styled.div`
  ${mediaColumns({ xs: [12, 0] })};
  display: flex;
  align-items: center;
  justify-content: center;

  ${mediaUp('md')} {
    justify-content: flex-end;
  }

  html[lang^='ar'] & {
    direction: ltr;
    justify-content: flex-start;
  }
`

export const ButtonNext = styled(ChevronRight)``

export const ButtonPrev = styled(ChevronLeft)``

export const TitleWrapper = styled.div`
  ${mediaColumns({ xs: [12, 0] })};

  ${mediaDown('md')} {
    margin-bottom: 18px;
  }
`

export const Content = styled.div`
  text-align: center;
`

export const IconWrapper = styled.div`
  width: 64px;
  height: 64px;
  margin: 0 auto 14px;
  background-color: ${colors.paleGrey};
  border-radius: 16px;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 2;
  position: relative;

  ${mediaUp('lg')} {
    width: 110px;
    height: 110px;
    margin: 0 auto 30px;
    border-radius: 28px;
  }
`

export const StepIcon = styled.img`
  width: 34px;
  height: 36px;

  ${mediaUp('lg')} {
    width: 69px;
    height: 72px;
  }

  &[data-step='step1'] {
    width: 69px;
    height: 72px;

    ${mediaUp('lg')} {
      width: 72px;
      height: 72px;
    }
  }

  &[data-step='step2'] {
    width: 36px;
    height: 36px;

    ${mediaUp('lg')} {
      width: 72px;
      height: 72px;
    }
  }

  &[data-step='step3'] {
    width: 36px;
    height: 36px;

    ${mediaUp('lg')} {
      width: 68px;
      height: 68px;
    }
  }

  &[data-step='step4'] {
    width: 28px;
    height: 36px;

    ${mediaUp('lg')} {
      width: 65px;
      height: 72px;
    }
  }

  &[data-step='step5'] {
    width: 28px;
    height: 36px;

    ${mediaUp('lg')} {
      width: 64px;
      height: 72px;
    }
  }
`

export const InfoText = styled(Text2)`
  ${mediaColumns({ xs: [6, 3] })};
  justify-self: center;
  text-align: center;
  margin-top: 80px;

  ${mediaDown('lg')} {
    display: none;
  }
`
